import React from 'react'

function NoAction() {
    return (
        <p>The Codex Did Not Find Any Specific Action</p>
    )
}

export default NoAction